function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M391.53,290.5a.253.253,0,0,0,.1-.343.261.261,0,0,0-.086-.094l-2.409-1.558a.509.509,0,0,0-.764.52l.43,2.576a.254.254,0,0,0,.293.209.282.282,0,0,0,.079-.027Z",
  transform: "translate(-388.368 -287.582)",
  fill: "#ff7e00"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M389.473,292.719a.254.254,0,0,0-.1.34l2.26,4.378a.509.509,0,0,0,.453.275h3.055a.508.508,0,0,0,.508-.509.516.516,0,0,0-.062-.245l-3.081-5.6a.257.257,0,0,0-.345-.1Z",
  transform: "translate(-388.35 -287.531)",
  fill: "#ff7e00"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M399.406,294.9H399.4a3.535,3.535,0,0,1-.648-.354.258.258,0,0,0-.357.068l-.01.017-1.265,2.268a.508.508,0,0,0,.2.692.516.516,0,0,0,.248.064h1.865a.509.509,0,0,0,.477-.329l.682-1.816a.256.256,0,0,0-.15-.329.25.25,0,0,0-.054-.014,3.557,3.557,0,0,1-.692-.159C399.6,294.972,399.5,294.937,399.406,294.9Z",
  transform: "translate(-388.21 -287.471)",
  fill: "#ff7e00"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M402.923,290.462a3.747,3.747,0,0,0-2.861-2.851.509.509,0,0,0-.546.775c.539.82.214,1.305-.359,2.03a3.638,3.638,0,0,0-.552.834,2.074,2.074,0,0,0,.993,2.759c.059.027.118.053.179.074a2.082,2.082,0,0,0,2.286-.262A3.425,3.425,0,0,0,402.923,290.462Z",
  transform: "translate(-388.185 -287.597)",
  fill: "#ff7e00"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M407.62,302.295a4.073,4.073,0,0,0-4.073-4.073h-.509v-.509a1.019,1.019,0,0,0-1.018-1.018H389.8a1.018,1.018,0,0,0-1.018,1.018v9.673a2.545,2.545,0,0,0,2.545,2.545h9.164a2.546,2.546,0,0,0,2.545-2.545v-1.018h.509A4.073,4.073,0,0,0,407.62,302.295Zm-4.073,2.036h-.255a.252.252,0,0,1-.255-.253v-3.566a.254.254,0,0,1,.253-.255h.257a2.036,2.036,0,1,1,0,4.073Z",
  transform: "translate(-388.36 -287.431)",
  fill: "#ffb238"
});

var SvgUxuiDesigner = function SvgUxuiDesigner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.26,
    height: 22.5,
    viewBox: "0 0 19.26 22.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUxuiDesigner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/uxui_designer.e3d98e03.svg";
export { ForwardRef as ReactComponent };